import { FilterOneItem } from "@/shared/components/GenericSearchBar/model/FilterOneItem";

export const PROFILE_CONSTANTS = {
  PATH: "/profile",
  PENDING_TASKS_TEXT: "Tareas pendientes",
  SEE_PROFILE: "Ver perfil",
  EMPTY_TITLE_NOTIFICATION: "Notificaciones",
  EMPTY_TITLE_TASK: "Tareas",
  EMPTY_TEXT_TASK: "No hay tareas pendientes para este usuario",
  EMPTY_TEXT_TASK_FILTER:
    "No hay tareas pendientes para este usuario con el filtro",
  EMPTY_TITLE_SERVICES: "Servicios",
  EMPTY_TEXT_SERVICES: "No hay servicios pendientes para este usuario",
  EMPTY_TEXT_NOTIFICATION_FILTER: "No hay notificaciones para este usuario",
  EMPTY_TEXT_NOTIFICATION: "No hay notificaciones para este usuario",
  EMPTY_TEXT_SERVICES_FILTER:
    "No hay servicios pendientes para este usuario con los filtros seleccionados",
  PROFILE_ITEMS: {
    DOCUMENT: "Documento",
    EMAIL: "Correo"
  },
  TABS: {
    TASKS: "Tareas",
    TIME_LINE: "Línea de tiempo",
    OTHER: "Otro",
    SERVICES: "Servicios"
  },
  EMIT_OPERATIONS: {
    DELETE_FORMS: "shouldDeleteForms",
    HANDLE_OPERATION: "handleOperation",
    CHOSEN_SERVICE: "chosenService",
    CLOSE_APPOINTMENT_MODAL: "closeAppointmentModal",
    CLOSE_MEDICAL_ORDER_MODAL: "closeMedicalOrderModal"
  },
  DIALOG_MESSAGES: {
    CHANGE_SERVICE_TITLE: "Cambiar de Servicio",
    CHANGE_SERVICE_TEXT:
      "¿Está seguro que desea iniciar un nuevo servicio? Se perderá el progreso",
    COMPLETE_SERVICE_TITLE: "Completar servicio",
    COMPLETE_SERVICE_TEXT:
      "¿Desea completar el servicio? Se volverá al listado",
    CANCEL_SERVICE_TITLE: "Cancelar servicio",
    CANCEL_SERVICE_TEXT: "¿Desea cancelar el servicio? Se volverá al listado"
  },
  FILTER_NAMES_TAGS: {
    SERVICES: ["Categorias", "Estado"],
    TASKS: ["Categoria", "Tipo", "Rol"]
  },
  CHIPS_INNER_NAME: {
    INNER: ["category", "type", "taskRoleName"]
  },
  WHERE_LOCATION: {
    LOCATION: ["services", "tasks"]
  },
  CHOSEN_SERVICES: {
    SERVICES: {
      VALUE: "services",
      SUB: {
        CATEGORY: "category",
        STATE: "state"
      }
    },
    TASKS: {
      VALUE: "tasks",
      SUB: {
        CATEGORY: "category",
        TASKROLENAME: "taskRoleName"
      }
    }
  },
  CHANGE_SERVICES: "changeServices",
  SELECCIONE_UNA: "Seleccione ",
  INPUT_FILTER: "inputFilter",
  USER_FILTERS: ["Nombre", "Teléfono", "Identificación"],
  USER_FILTERS_NAMES: {
    NAME: "Nombre",
    PHONE: "Teléfono",
    ID: "Identificación"
  },
  LABELS: {
    USER: "Usuario por ",
    LOAD_MORE_TEXT: "Cargar más opciones",
    TASK_CATEGORY: "Tarea:",
    SERVICE: "Servicio",
    DATE: "Fecha",
    CAMPUS: "Sede",
    PLACE: "Espacio",
    OBSERVATION: "Observación",
    SCHEDULE: "Agendar cita",
    APPOINTMENT: "Detalle cita",
    CONFIRM_APPOINTMENT: "Confirmar cita",
    CANCEL_APPOINTMENT: "Cancelar cita",
    COMPLETE_APPOINTMENT: "Completar cita",
    PATIENT: "Paciente",
    GENERATE_PDF: "Generar PDF",
    INVOICE_SERVICE: "Facturar servicio",
    EDIT: "Editar",
    PREVIEW: "Visualizar Pdf",
    CHANGE_SERVICE_STATE: "Cambiar estado"
  },
  HINT: {
    USER: "Seleccione un usuario"
  },
  RESPONSABLE: "Responsable",
  CREATE_ORDER: "Crear Orden",
  SERVICES_PROVIDED: "servicesProvided",
  SERVICE_EMPTY_TEXT: "El servicio no posee progreso",
  SERVICE_EMPTY_TITLE: "No hay contenido para el servicio seleccionado"
};
export const MAX_WIDTH_MODALS = "1000px";

export const SAME_TIME_RANGE_SERVICE_MESSAGE = {
  FIRST_PART: "Actualmente tiene",
  SECOND_PART:
    "cita asignada para el mismo servicio en el mismo rango horario, debe escoger otro espacio para reservar"
};

export const DIFFERENT_SERVICE_SAME_RANGE_TIME_MESSAGE = {
  FIRST_PART_PLURAL: "Ya tiene los siguientes servicios:<strong>",
  FIRST_PART_SINGULAR: "Ya tiene el siguiente servicio: <strong>",
  SECOND_PART_SINGULAR:
    "</strong>, asignado en el mismo rango horario, desea asignar el servicio de todas formas?",
  SECOND_PART_PLURAL:
    "</strong>,  asignados en el mismo rango horario, desea asignar el servicio de todas formas?"
};

export const ERROR_FORM = "Hubo un error al consultar el formulario.";

export const ERROR_SESSION = "Hubo un error al consultar la session";

export const FILTER_SEARCH_TASKS_PROFILE: FilterOneItem = {
  labelTitle: " de tarea",
  labelNotFound: "No se encontró tarea para esa busqueda",
  labelAddTitle: "No se encontró tarea con esta busqueda",
  labelAddSubTitle: " Crear nuevo tarea",
  addIcon: "mdi-plus-circle-outline",
  filterOut: true,
  listItemFilterObj: {},
  filters: [
    { name: "Nombre", id: "name", default: true },
    { name: "Categoria", id: "category", oneResult: true }
  ]
};

export const FILTER_SEARCH_NOTIFICATION_PROFILE: FilterOneItem = {
  labelTitle: " de Notificación",
  labelNotFound: "No se encontró notificación para esa busqueda",
  labelAddTitle: "No se encontró notificación con esta busqueda",
  labelAddSubTitle: " Crear nuevo servicio",
  addIcon: "mdi-plus-circle-outline",
  filterOut: true,
  listItemFilterObj: {},
  filters: [
    { name: "Nombre", id: "title", default: true },
    { name: "Estado", id: "state", oneResult: true },
    { name: "Canales", id: "channels", oneResult: true }
  ]
};

export const FILTER_SEARCH_SERVICE_PROFILE: FilterOneItem = {
  labelTitle: " de servicio",
  labelNotFound: "No se encontró servicio para esa busqueda",
  labelAddTitle: "No se encontró servicio con esta busqueda",
  labelAddSubTitle: " Crear nuevo servicio",
  addIcon: "mdi-plus-circle-outline",
  filterOut: true,
  listItemFilterObj: {},
  filters: [
    { name: "Nombre", id: "internalName", default: true },
    { name: "Categoria", id: "category", oneResult: true },
    { name: "Estado", id: "state", oneResult: true }
  ]
};

export const FILTER_SEARCH_USER_CONSTANTS: FilterOneItem = {
  labelTitle: " del usuario",
  labelNotFound: "No se encontró usuario para esa busqueda",
  labelAddTitle: "No se encontró usuario con este documento",
  labelAddSubTitle: " Crear nuevo usuario",
  labelHint: "Seleccione un usuario",
  addIcon: "mdi-plus-circle-outline",
  filterIcon: true,
  filters: [
    { name: "Nombre", id: "name" },
    {
      name: "Documento",
      id: "userDocument",
      default: true,
      oneResult: true
    },
    { name: "Correo", id: "userEmail", oneResult: true }
  ]
};
export const PROFILE_CRUMBS_CONSTANTS = {
  FROM: {
    PROFILE: "profile",
    ROUTE_MAP: "routeMap"
  },
  TYPE: {
    SERVICE_ADDED: "ServiceAdded",
    SERVICE_REMOVED: "ServiceRemoved",
    INITIAL: "Initial"
  },
  ACTION: { UPDATE_ROUTE: "updateRoute", INITIAL_ROUTE: "initialRoute" },
  ROUTES: {
    INITIAL: "profileInitial",
    SERVICE: "ProfileService"
  }
};
export const COMPLETE_SERVICE = "Completado";

export const SECTIONS_SERVICE = "sections";

export const GROUPS_SERVICE = "groups";

export const POP_STATE_EVENT = "popstate";

export const SERVICELIST_ID = "serviceListElement";

export const TASKLIST_ID = "taskListElement";

export const NOTIFICATION_ID = "notificationListElement";

export const NOTIFICATION_CONSTANTS = {
  LOCAL_HOUR: "es-CO",
  STATIC_CHANNELS: ["email", "sms", "push", "whatsapp"],
  STATIC_STATES: [
    "Programada",
    "Ejecutada",
    "Cancelada",
    "En ejecución",
    "Error"
  ],
  STATIC_RESEND: "Reenviada",
  STATIC_FILTERS: { TITLE: "title", CHANNELS: "channels", STATES: "state" },
  STATIC_FLAGTYPES: {
    PROGRAMADA: "Programada",
    REGLA: "Regla"
  },
  REFRESH_NOTIFICATION_LIST: "refreshNotificationList",
  STATIC_CANCELATION: "Cancelada",
  STATIC_ERROR: "Error",
  STATIC_EXECUTED: "Ejecutada",
  STATIC_SCHEDULED: "Programada",
  STATIC_PENDING: "Pendiente",
  STATIC_IN_EXECUTION: "En ejecución",
  MESSAGE_MODAL: {
    TITLE: "Cancelar notificación",
    BODY: "¿Desea cancelar la notificación?",
    RESEND_CONFIRMATION: "Confirmación reenvio de notificación",
    TEXT_CONFIRMATION: "¿Esta seguro de reenviar la notificacion?"
  },

  MESSAGES_RESPONSE: {
    SUCCESS: "Notificación enviada exitosamente",
    ERROR: "Hubo un error al enviar la notificación",
    UPDATE: "Notificación actualizada exitosamente",
    CANCEL: "Notificación cancelada exitosamente",
    SENDING: "Reenviando notificacion...",
    INSUFFICIENT_DATA:
      "No hay datos sificientes para enviar el reenviar el mensaje"
  },
  BTN_HINT: "Ver detalles",
  SHOW_DETAILS: "Ver detalles",
  LABELS_DETAILS: {
    DESCRIPTION: "Descripción",
    EMAIL: "Correo electrónico",
    PHONE: "Teléfono"
  }
};

export const LIST_QUERY = {
  ACTIVO: "Activo",
  PACIENTE: "Paciente",
  ADMINISTRATIVA: "Administrativa"
};

export const EXTRA_CONSTANTS = {
  GROUP: "Grupo",
  MINUS_INDEX: -1
};
